import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/WelcomePage.css";

const WelcomePage = () => {
  const [headerText, setHeaderText] = useState("");
  const navigate = useNavigate();
  const fullText = "the collectors platform";

  const year = useMemo(() => new Date().getFullYear(), []);

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      if (index < fullText.length) {
        setHeaderText(fullText.substring(0, index + 1));
        index++;
      } else {
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="WelcomePage">
      {/* Top-right auth */}
      <nav className="WelcomePage-auth" aria-label="account">
        <button
        type="button"
        className="auth-link auth-link--primary auth-link--pulse"
        onClick={() => navigate("/new")}
        aria-label="sign up"
      >
        sign up
      </button>
        <span className="auth-sep" aria-hidden="true">
          ·
        </span>
        <button
          type="button"
          className="auth-link auth-link--quiet"
          onClick={() => navigate("/returning")}
          aria-label="log in"
        >
          log in
        </button>
      </nav>

      <header className="WelcomePage-hero">
        <h1 className="home-title">{headerText}</h1>
        <p className="welcome-subtitle">
  a quiet space for documenting the things you collect,
  <br />
  and the stories behind them.
</p>
      </header>

      <main className="WelcomePage-main">
        <button aria-label="learn more" onClick={() => navigate("/about")}>
          about the platform
        </button>

        <button
          aria-label="discover public items"
          onClick={() => navigate("/discover")}
        >
          browse public collections
        </button>

        <button aria-label="take the tour" onClick={() => navigate("/overview")}>
          see how it works
        </button>
      </main>

      <p className="development-note-welcome" aria-live="polite"></p>
      <div className="app-version" aria-hidden="true">
        version 0.99 <span className="year-stamp">({year})</span>
      </div>
    </div>
  );
};

export default WelcomePage;